function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.50364 3.48401H0V4.64156H4.50364V3.48401Z",
  fill: "#1442A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.41705 1.03589L4.93701 2.79095L5.45351 1.75506L1.93355 -9.65152e-07L1.41705 1.03589Z",
  fill: "#1442A8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.41683 7.15576L1.93298 8.19189L5.45373 6.438L4.93758 5.40188L1.41683 7.15576Z",
  fill: "#1442A8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7557 8.83189C20.7557 6.64335 25 5.91988 25 5.91988V1.67553H6.47962L8.40887 6.30573L11.0141 6.72168L9.4144 10.9421L10.4967 11.3526L12.1817 6.90766L13.0576 7.04772C14.3733 7.3182 14.5821 8.73273 14.5821 9.21736C14.5821 9.21736 14.5821 9.81118 14.5821 10.5497C14.5821 11.1821 14.5821 12.2521 14.5821 13.0759C14.5821 14.4082 13.3115 15.7745 13.1548 15.9169C11.6747 17.2619 8.71523 19.9532 7.23589 21.2983C6.60734 21.869 6.09338 22.8969 6.09338 24.2651C6.09338 26.3873 6.09338 34.472 6.09338 34.472H24.2283V29.0701V21.3531V21.1783C24.2283 17.8805 20.7557 14.7937 20.7557 11.1462V10.5493V8.83189ZM23.0708 29.0709H16.1255V21.3539H23.0708V29.0709ZM15.7396 10.5501V9.21774C15.7396 8.17788 15.2241 6.3119 13.291 5.91371L13.2656 5.90831L13.2401 5.90445L9.22919 5.26394L8.21633 2.83269H23.8425V4.99616C22.3157 5.41365 19.5981 6.48592 19.5981 8.83112V10.5493H15.7396V10.5501Z",
  fill: "#1442A8"
});

var SvgDisinfection = function SvgDisinfection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 35,
    viewBox: "0 0 25 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisinfection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disinfection.a7df9ab4.svg";
export { ForwardRef as ReactComponent };